import React from "react";
import HomePage from "./pages/home/HomePage";

const App = () => {
  return <HomePage />;
};

export default App;
